import { render, staticRenderFns } from "./KaufschutzForm.vue?vue&type=template&id=0f531cd2&"
import script from "./KaufschutzForm.vue?vue&type=script&lang=js&"
export * from "./KaufschutzForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports